import { download, downloadEx, put, get } from "./api";

const controller = 'Storage';

export const getClientInfo = async (customerId) => {
  return await get(`api/${controller}/status/clients`);
}

export const downloadZip = async (customerId, environmentId, serverId) => {
  return await download(`api/${controller}/download/${environmentId}/${serverId}`, "MetaDir.zip");
}

export const downloadZipEx = async (customerId, environmentId, serverId, fnHandleData) => {
  return await downloadEx(`api/${controller}/download/${environmentId}/${serverId}`, "MetaDir.zip", fnHandleData);
}

export const setDownloadStatus = async (sessionId, data) => {
  return await put(`api/${controller}/status/${sessionId}`, data);
}

